import { get, post, put, deleted } from '..';
import routes from './routes';

const DeliveryTimeSlotServices = {
  createDeliveryTimeSlot: async (obj) => {
    const data = await post(routes.createDeliveryTimeSlot, obj);
    return data;
  },
  getDeliveryTimeSlots: async (params) => {
    const data = await get(routes.getDeliveryTimeSlots, params);
    return data;
  },
  getDeliveryTimeSlotById: async (id) => {
    const data = await get(routes.getDeliveryTimeSlotById + id);
    return data;
  },
  updateDeliveryTimeSlot: async (id, obj) => {
    const data = await put(routes.updateDeliveryTimeSlot + id, obj);
    return data;
  },
  deleteDeliveryTimeSlot: async (id) => {
    const data = await deleted(routes.deleteDeliveryTimeSlot + id);
    return data;
  },
}

export default DeliveryTimeSlotServices